export const ageText = (customer: any) => {
  return customer.age === null
    ? "만 -세"
    : customer.age === 0
    ? `만 ${customer.ageMonth}개월`
    : `만 ${customer.age}세`;
};
